import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const TransactionPayment = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="-4 -3 21 20" fill="none">
    <g fillRule="evenodd" clipRule="evenodd" fill="currentColor">
      <path d="M2.5 0.293015C1.11929 0.293015 0 1.4123 0 2.79302V12.0001L1.5 13.5001L2.5 12.5001L3.5 13.5001L4.5 12.5001L5.5 13.5001L6.5 12.5001L7.5 13.5001L8.5 12.5001L9.5 13.5001L11 12.0001V4.29302H15V2.79302C15 1.4123 13.8807 0.293015 12.5 0.293015H2.5ZM12.5 1.29302C11.6716 1.29302 11 1.96459 11 2.79302V3.29302H14V2.79302C14 1.96459 13.3284 1.29302 12.5 1.29302ZM2.5 1.29302H10.4998C10.186 1.71085 10 2.23021 10 2.79302V11.5859L9.5 12.0859L8.5 11.0859L7.5 12.0859L6.5 11.0859L5.5 12.0859L4.5 11.0859L3.5 12.0859L2.5 11.0859L1.5 12.0859L1 11.5859V2.79302C1 1.96459 1.67157 1.29302 2.5 1.29302Z" />
      <path d="M8.5 4.29302H2.5V3.29302H8.5V4.29302Z" />
      <path d="M8.5 6.79302H2.5V5.79302H8.5V6.79302Z" />
      <path d="M6.5 9.29302H2.5V8.29302H6.5V9.29302Z" />
    </g>
  </svg>,
  'TransactionPayment'
);
